import { createFileRoute } from "@tanstack/react-router";
import { PublicBuchung } from "@/pages/PublicBuchen";

/** Die Bestätigungsseite einer Buchung aus der Mail: ansehen und absagen (13.09.2026). */
export const Route = createFileRoute("/buchung/$token")({
	component: BuchungSeite,
});

function BuchungSeite() {
	const { token } = Route.useParams();
	return <PublicBuchung token={token} />;
}
